import { moduleFactory } from './../scripts/lib';

import Select from './Forms/Select/Select.static';
import Tabs from './Tabs/Tabs.static';
import Modal from './Modal/Modal.static';
import Dropdown from './Dropdown/Dropdown.static';
import Tooltip from './Tooltip/Tooltip.static';
import Header from './Header/Header.static';
import Slider from './Slider/Slider.static';

window.myApp = window.myApp || {};

window.addEventListener('DOMContentLoaded', () => {
  window.myApp.selects = moduleFactory(Select, '[data-select]');
  window.myApp.tabs = moduleFactory(Tabs, '[role="tablist"]');
  window.myApp.modals = moduleFactory(Modal, '[data-modal]');
  window.myApp.dropdown = moduleFactory(Dropdown, '[data-dropdown]');
  window.myApp.tooltip = moduleFactory(Tooltip, '[data-tooltip]');
  window.myApp.header = moduleFactory(Header, '#page-header');
  window.myApp.slider = moduleFactory(Slider, '[data-slider]');
});



// WEBPACK FOOTER //
// ./src/components/static.js